import React, { useEffect, useState } from 'react'
import GetORPostAsync from '../constants/restservice';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
const levelname = ["SAREE KIT", "MENS FASHION", "HOT KETTLE AND FOOD CHOPPER", "GROCERY KIT", "ORGANIC NAPKIN KIT", "MENS WEAR", "KURTHIS KIT", "RUBY KIT", "EMERALD KIT", "SAPPHIRE KIT", "PEARL KIT"];
const levelprices = [1600, 2200, 2600, 2600, 2600, 2600, 2600, 3500, 3500, 3500, 3500];
const levelbvs = [30, 30, 40, 40, 40, 40, 40, 100, 100, 100, 100];
function Buypackage() {
    let previousProgress = false;
    const navigate = useNavigate();
    const [memberid, setMemberid] = useState(localStorage.getItem("username"));
    const [membername, setMembername] = useState("");
    const [selforothers, setSelforOthers] = useState("self");
    const [tableData, settableData] = useState("");
    useEffect(() => {
        GetTransactions();
    }, [])
    const PurchasePackage = async (pid) => {
        if (!previousProgress) {
            previousProgress = true;
            let json = {
                package: levelprices[pid - 1],
                memberid,
                packagename: levelname[pid - 1]
            };
            let res = await GetORPostAsync("buycontractConfirm.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
            if (res.status === "error") {
                toast(res.message);
                previousProgress = false;
                if (res.message === "Session Expired") {
                    navigate("/");
                }
                return;
            }
            Swal.fire({
                text: `Are you sure want to purchase ${levelname[pid - 1]}`,
                title: "Package Amount : " + levelprices[pid - 1],
                icon: "info",
                showCancelButton: true,
                cancelButtonText: 'Cancel'
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        confirmPurchase(pid);
                    } else {
                        previousProgress = false;
                    }
                });
        } else {
            toast("Previous purchase on progress");
        }

    }
    const confirmPurchase = async (pid) => {
        if (!memberid) {
            return toast.error("Enter valid memberid");
        }
        let json = {
            package: levelprices[pid - 1],
            memberid,
            packagename: levelname[pid - 1]
        };
        let res = await GetORPostAsync("buycontract.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            previousProgress = false;
            if (res.message === "Session Expired") {
                navigate("/")
            }
            return;
        }
        toast(res.message);
        previousProgress = false;
    }
    const getName = async () => {
        if (!memberid) {
            return;
        }
        let jsoninput = {
            memberid: memberid
        }
        let res = await GetORPostAsync("getname.asp", "POST", JSON.stringify(jsoninput), localStorage.getItem("token"));
        if (res.status === "error") {
            toast.error(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setMembername(res.fullname);
    }
    const GetTransactions = async () => {
        let res = await GetORPostAsync("GetPurchasePortfolio.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        settableData(res.items);
    }

    return (
        <div>
            <div className="page-header">
                <div className="page-leftheader">
                    <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                    {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Buy Package</label></li>
                </ol> */}
                </div>
            </div>
            <div className="row" style={{ display: "flex" }}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body" style={{ justifyContent: "center" }}>
                            <h5 className=" mt-3 mb-3">Activate</h5>
                            <div className="search-element row mb-5">
                                <div className="input-container col-lg-4" style={{ justifyContent: "center", alignItems: "center" }}>
                                    <input type="radio" id="self" className="form-radio-control" name="selforothers" onChange={(e) => {
                                        setSelforOthers(e.target.value);
                                        setMemberid(localStorage.getItem("username"));
                                    }} value="self" checked={selforothers === "self"} />
                                    <label htmlFor="self" className="ml-1 mr-3 mt-auto mb-auto" style={{ fontWeight: "bold" }}>Self</label>

                                    <input type="radio" id="Others" className="form-radio-control" name="selforothers" onChange={(e) => {
                                        setSelforOthers(e.target.value);
                                    }} value="Others" checked={selforothers === "Others"} />
                                    <label htmlFor="Others" className="ml-1 mt-auto mb-auto" style={{ fontWeight: "bold" }}>Others</label>

                                </div>
                            </div>
                            <div className="search-element row mb-5" style={{ display: selforothers === "Others" ? "flex" : "none" }}>
                                <div className="input-container">
                                    <i className="las la-user-circle inputicon"></i>
                                    <input type="text" className="form-control col-lg-4" onBlur={(e) => getName()} placeholder="Member Id" aria-label="accountnumber" tabIndex="1" onChange={(e) => {
                                        setMemberid(e.target.value);
                                    }} value={memberid} />
                                </div>
                            </div>

                            <div className="search-element row mb-5" style={{ display: selforothers === "Others" ? "flex" : "none" }}>
                                <div className="input-container">
                                    <i className="las la-user inputicon"></i>
                                    <input type="text" className="form-control col-lg-4" placeholder="Full name" aria-label="fullname" tabIndex="1" readOnly value={membername} />
                                </div>
                            </div>
                            {/* <div style={{ justifyContent: "center", display: "grid" }} className="col-lg-4">
                                <button className=" mb-5 btn primebtn" onClick={(e) => {
                                    if (!memberid && selforothers === "Others") {
                                        toast.error("Enter valid memberid");
                                        return;
                                    }
                                    let mem = selforothers === "Others" ? memberid : localStorage.getItem("username")
                                    navigate(`/buypackage/${mem}`)
                                }}>Next</button>
                            </div> */}
                            <div className="row" style={{ display: "flex" }}>
                                {
                                    levelprices.map((element, index) => (
                                        <div className="col-lg-4" key={index}>
                                            <div className="card overflow-hidden dash1-card border-1 border-primary">
                                                <div className="card-body">
                                                    <h5 className="number-font" style={{ marginBottom: "0px", marginTop: "5px" }}>{element}</h5>
                                                    <p className=" mb-1 ">{levelbvs[index]} PV</p>
                                                    <h6 className={` mb-0 mt-2 highlight text-center bg-warning shk`} style={{ color: "black" }}>{levelname[index]}</h6>
                                                    <label style={{ color: "white", cursor: "pointer" }}>
                                                        <span className={`ratio`} onClick={() => PurchasePackage(index + 1)}>
                                                            <i className="fe fe-shopping-cart mr-1"></i> Buy
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                History
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Package</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData.length <= 0 ? <tr>
                                                <td colSpan="3">No Details Found</td>
                                            </tr> :
                                                tableData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.CreatedDate}</td>
                                                        <td>{item.package.replace('$', 'RM')}</td>
                                                    </tr>
                                                ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Buypackage
